import(/* webpackMode: "eager" */ "/app/src/app/esm-2to1-prediction/page.tsx");
